export const FETCH_ALL_EVENTS_BEGIN = 'FETCH_ALL_EVENTS_BEGIN';
export const FETCH_ALL_EVENTS_SUCCESS = 'FETCH_ALL_EVENTS_SUCCESS';
export const FETCH_ALL_EVENTS_FAILURE = 'FETCH_ALL_EVENTS_FAILURE';

export const FETCH_RECURRENT_EVENTS_BEGIN = 'FETCH_RECURRENT_EVENTS_BEGIN';
export const FETCH_RECURRENT_EVENTS_SUCCESS = 'FETCH_RECURRENT_EVENTS_SUCCESS';
export const FETCH_RECURRENT_EVENTS_FAILURE = 'FETCH_RECURRENT_EVENTS_FAILURE';

export const CREATE_EVENT_BEGIN = 'CREATE_EVENT_BEGIN';
export const CREATE_EVENT_SUCCESS = 'CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILURE = 'CREATE_EVENT_FAILURE';

export const DELETE_EVENT_BEGIN = 'DELETE_EVENT_BEGIN';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'DELETE_EVENT_FAILURE';

export const FETCH_FORECASTS_BEGIN = 'FETCH_FORECASTS_BEGIN';
export const FETCH_FORECASTS_SUCCESS = 'FETCH_FORECASTS_SUCCESS';
export const FETCH_FORECASTS_FAILURE = 'FETCH_FORECASTS_FAILURE';

export const RENDER_BEGIN = 'RENDER_BEGIN';
export const RENDER_SUCCESS = 'RENDER_SUCCESS';